const positiveFloatRegExp =
  /^\d{1,3}((:?,\d{3})*|(:? \d{3})*|(:?\d{3})*)(\.\d+)?$/;
const removeSeparatorsRegExp = / |,/g;

export const parsePositiveFloat = (value: string) =>
  positiveFloatRegExp.test(value)
    ? Number.parseFloat(value.replaceAll(removeSeparatorsRegExp, ''))
    : NaN;
